import { newAxiosInstance } from "../axiosInstance";

export interface ContactUsData {
    name: string;
    email: string;
    phone: string;
    companyName?: string;
    companyAddress?: string;
    message: string;
}

export const createContactUs = async (data: ContactUsData) => {
    try {
        const payload = {
            name: data.name,
            email: data.email,
            phone: data.phone,
            company_name: data.companyName,
            company_address: data.companyAddress,
            message: data.message
        };
        const response = await newAxiosInstance.post("/contacts", payload);
        return response.data;
    } catch (error) {
        console.error("Error submitting contact form:", error);
        throw error;
    }
};
